import * as Yup from 'yup'

// tslint:disable:only-arrow-functions
Yup.addMethod<Yup.NumberSchema>(Yup.number, 'priceField', function (message) {
  return this.test('priceField', message, function (value) {
    return value >= 0
  })
})
